import { RoomModel } from "@app/catalog";

export class RoomAddedMessage {
    public room: RoomModel;
    
    constructor(room: RoomModel)
    {
        this.room = room;
    }
}